<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4 class="mb-4">Interconsultas por Fecha</h4>
    <hr>

    <!--  Botones de rango rápido  -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-outline-primary"   @click="setDateRange(getToday)">Hoy</button>
      <button class="btn btn-outline-danger"    @click="setDateRange(getThisWeek)">Semana Actual</button>
      <button class="btn btn-outline-secondary" @click="setDateRange(getThisMonth)">Mes Actual</button>
      <button class="btn btn-outline-success"   @click="setDateRange(getThisQuarter)">Trimestre Actual</button>
      <button class="btn btn-outline-info"      @click="setDateRange(getThisSemester)">Semestre Actual</button>
      <button class="btn btn-outline-warning"   @click="setDateRange(getThisYear)">Año Actual</button>
    </div>

<!--  Selector de fechas  -->
<div class="fecha-bar mb-3">
  <div class="fecha-campo">
    <label class="form-label">Desde</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaDesde">
  </div>
  <div class="fecha-campo">
    <label class="form-label">Hasta</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaHasta">
  </div>
  <button class="btn btn-dark btn-icono" @click="fetchInterconsultas()">
    <span class="material-symbols-outlined">search</span>
    Consultar
  </button>
</div>

    <!--  DataTable  -->
    <DataTable
      :data="interconsultas"
      :columns="columnas"
      idField="idInterconsulta"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay interconsultas para el rango de fechas seleccionado."
      @refresh="fetchInterconsultas()"
    >
      <!-- Fechas formateadas -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>

      <template #cell-fechaAct="{ row }">
        {{ getFormattedDate(row.fechaAct) || 'N/A' }}
      </template>

      <!-- Estado con color -->
      <template #cell-estadoInter="{ row }">
        <span class="badge-estado" :class="getClassForEstadoInter(row.estadoInter)">
          {{ row.estadoInter }}
        </span>
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import Swal       from 'sweetalert2'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

export default {
  name: 'InterconsultasPorFecha',
  components: { Layout, Footer, DataTable },

  data() {
    return {
      fechaDesde:     '',
      fechaHasta:     '',
      interconsultas: [],

      getToday, getThisWeek, getThisMonth,
      getThisQuarter, getThisSemester, getThisYear,

      columnas: [
        { field: 'idInterconsulta', label: 'ID Interconsulta' },
        { field: 'especialidad',    label: 'Especialidad' },
        { field: 'medico',          label: 'Médico' },
        { field: 'motivo',          label: 'Motivo' },
        { field: 'cuadro',          label: 'Cuadro Clínico' },
        { field: 'estadoInter',     label: 'Estado' },
        { field: 'fechaReg',        label: 'Fecha Registro' },
        { field: 'fechaAct',        label: 'Fecha Actualización' },
      ],
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    setDateRange(getRangeFunction) {
      const { fechaDesde, fechaHasta } = getRangeFunction()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.fetchInterconsultas()
    },

    validarFechas() {
      if (!this.fechaDesde || !this.fechaHasta) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos requeridos',
          text: 'Debe seleccionar las fechas desde y hasta.',
          confirmButtonText: 'Aceptar',
        })
        return false
      }
      return true
    },

    fetchInterconsultas() {
      if (!this.validarFechas()) return
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get('/vwinterconsultas/por-fecha', {
        params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
      })
      .then(response => { this.interconsultas = response.data })
      .catch(error   => console.error('Error fetching interconsultas:', error))
    },

    getClassForEstadoInter(estado) {
      return {
        'SOLICITADA': 'solicitada',
        'ASIGNADA':   'asignada',
        'PROCESO':    'proceso',
        'RECHAZADA':  'rechazada',
        'FINALIZADA': 'finalizada',
      }[estado] || ''
    },
  },
}
</script>

<style src="@/assets/css/fechaBar.css" scoped></style>
<style scoped>
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}
.solicitada { background-color: #ffecb3; }
.asignada   { background-color: #b3e5fc; }
.proceso    { background-color: #c8e6c9; }
.rechazada  { background-color: #ef9a9a; }
.finalizada { background-color: #a5d6a7; }
</style>